import React, {memo} from 'react';
import {IconType} from 'react-icons';
import {NamedProps} from 'react-select/src/Select';
import {UiDropdown} from '~/components/elements';

interface Props {
  onChange: NamedProps['onChange'];
  includeAll?: boolean;
  defaultItem?: {label: string; value: any};
  [key: string]: any;
  options: {label: string; value: any}[];
  selectedFontWeight?: string;
  icon?: IconType;
  styles?: React.CSSProperties;
  styleControl?: React.CSSProperties;
}

const CustomDropdown = ({
  includeAll = false,
  onChange,
  defaultItem,
  options,
  selectedFontWeight,
  icon,
  styles,
  styleControl,
  ...rest
}: Props) => {
  const defaultValue = {
    label: defaultItem?.label,
    value: defaultItem?.value,
  };
  if (includeAll) {
    options.unshift({label: 'All', value: 'all'});
  }

  const onChangeLocal: NamedProps['onChange'] = (value, action) => {
    if (!onChange) {
      return null;
    }
    if (value?.value === 'all') {
      onChange(null, action);
    } else {
      onChange(value, action);
    }
  };

  return (
    <UiDropdown
      defaultValue={includeAll ? {label: 'All', value: 'all'} : defaultItem?.label ? defaultValue : undefined}
      options={options}
      selection
      onChange={onChangeLocal}
      styles={{...styles, minWidth: '7em'}}
      styleControl={{...styleControl}}
      selectedFontWeight={selectedFontWeight}
      icon={icon}
      {...rest}
    />
  );
};

export default memo(CustomDropdown);
